var DropSelectDrilldown = require('sma.admin/components/dropdowns/dropselectdrilldown')

/* pass in items as a list of objects like this:
 * {
 *     name: 'foo',
 *     text: 'foobar',
 *     items: [{
 *         name: 'subfoo',
 *         text: 'subfoobar',
 *         checked: true
 *     }]
 * }
 */
class DropSelectorDrilldown extends DropSelectDrilldown {

	initialize (options) {
		this.checkboxItems = false;
		this.selector = true;
		this.noFooter = true;
		this.noCount = true;
		this.changeTitleAfterSelection = true;
		this.singleSelect = true;

		options.checkboxItems = false;


		super.initialize(options);
	}

	populateFromSelectBox (options) {
		if (this.$selectEl.attr('multiple')) {
			this.singleSelect = false;
		}

		var $optGroups = this.$selectEl.find('optgroup');
		var groups = [];

		//create the list of items
		if ($optGroups.length > 0) {
			$optGroups.each((i, group) => {
				var $group = $(group);

				var group = {
					name: i.toString(),
					text: $group.prop('label'),
					items: [],
				}

				var $items = $group.find('option');

				$items.each((j, item) => {
					var $item = $(item);
					var selected = $item.is(':selected');
					var disabled = $item.attr('disabled');

					group.items.push({
						name: $item.val(),
						text: $item.text(),
						selected: selected,
						header: disabled
					});

					if (selected) {
						this.selectedGroupIndex = i;
					}
				});

				groups.push(group);
			});
		} else {

		}

		options.items = groups;
		let title = this.updateTitleFromSelect();
		if (title) {
			options.title = title;
		}

	}

	unSelectAll () {
		this.$el.find('.sma-js-action-item').removeClass('active');

		for (let group of this.changedItems) {
			for (let item of group.items) {
				item.selected = false;
			}
		}
	}

	val (newSelected) {
		if (newSelected) {
			this.unSelectAll();
			this.updateChangedItems();

			for (let group of this.changedItems) {
				for (let item of group.items) {
					if (
						(newSelected instanceof Array && (newSelected.indexOf(item.name) !== -1)) ||
						item.name === newSelected
					) {
						item.selected = true;
						this.changeTitle(item.text);
					}
				}
			}

			this.$selectEl.val(newSelected);
			this.renderContents();
		}

		return this.$selectEl.val();
	}

	get wrapped () {
		return $('<div></div>').append(this.$selectEl).append(this.$el);
	}

}

module.exports = DropSelectorDrilldown;
